import { types as actions } from '../actions';

const defaultState = {
  errorMessage: ''
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.UPDATE_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.msg
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/error-banner/index.js